<template>
	<div class="centre-low-battery-warning">
		<div class="tracker finish-commissioning" v-if="lowCount > 0 || criticalCount > 0">
			<h2>Batteries are running low or critical</h2>
			<p>You need to follow up on the following steps:</p>
			<p>
                <span v-if="lowCount">
                    <span class="fa fa-exclamation-triangle"></span>
				    <span >{{lowCount}} batteries are running low.</span><br />
                </span>
                <span v-if="criticalCount">
                    <span class="fa fa-remove"></span>
				    <span v-if="criticalCount">{{criticalCount}} batteries are on critical.</span><br />
                </span>
				<span>Go to the hardware overview to see the battery status of each lock</span><br />
				<a class="btn btn-link btn-link-only" href="/centre/hardware">Go to hardware overview</a>
			</p>
		</div>
	</div>
</template>
<script>
	import Hardware from "../Services/Hardware";

	export default {

		props: ['centreId'],

		data: () => { return {
            lowCount: 0,
            criticalCount: 0,
		}},

		mounted: function () {
			this.refreshStatus();
		},

		methods: {
			refreshStatus: async function() {
                const {low_battery_count: lowCount, critical_battery_count: criticalCount} = await Hardware.getNumLocksWithLowBattery(this.centreId);
                this.lowCount = lowCount;
                this.criticalCount = criticalCount;
			}
		}

	}
</script>
